import { useTranslation } from "react-i18next";
import BinIcon from "assets/icons/bin.svg?react";
import DeskIcon from "assets/icons/book.svg?react";
import DeskRemoveIcon from "assets/icons/bookr.svg?react";
import EditIcon from "assets/icons/mode_edit.svg?react";
import { RefObject, useContext, useEffect, useRef, useState } from "react";


import { axiosInstance } from "api/axios";
import casesService from "api/casesService";
import deskService from "api/deskService";
import NewTabIcon from "assets/icons/new_tab.svg?react";
import { ECaseViews } from "components/CaseView/dto/ECaseViews";
import CasesContext from "contexts/CasesContext";
import { ICaseSimple } from "dto/Cases/ICaseSimple";
import { IWorkspaceMember } from "dto/IWorkspace";
import { useOnClickOutside } from "hooks/useClickOutside";
import { useAuth } from "react-oidc-context";
import { useNavigate, useParams } from "react-router-dom";
import { getKeys } from "utils/getKeys";
import { getUserId } from "utils/getUserId";
import { readAsBase64 } from "utils/readAsBase64";

import LabelIcon from "assets/icons/label-new.svg?react";

import OptionsCard from "components/OptionsCard/OptionsCard";
import { Option } from "components/OptionsCard/typings";
import { reEncrypt } from "utils/reEncrypt";

import CalendarIcon from "assets/icons/calendar.svg?react";
import FlagIcon from "assets/icons/flag_border.svg?react";
import ForwardIcon from "assets/icons/forward.svg?react";
import LinkIcon from "assets/icons/link.svg?react";
import ModalsManagerContext from "contexts/ModalsManager";
import { AbilityContext } from "contexts/AbilityContext";
import Popper from "components/Popper";
import StatusModal from "components/StatusModal";
import { IStatus } from "dto/IStatus";
import ChooseTagNew from "components/ChooseTagNew";
import { ITag, TagType } from "dto/ITag";

const CaseOptionsCard = ({
  refWrapper,
  pack,
  showOptions,
  toggle,
  selectedElements,
  rightSide = false,
  dropdown = false,
  isRightClicked = false,
  statuses,
}: {
  refWrapper: RefObject<HTMLDivElement>;
  pack: ICaseSimple;
  showSomething: boolean;
  showOptions: boolean;
  onClickEdit: () => void;
  onClickAttachIcon: (state: boolean) => void;
  refetch: () => void;
  showDropdown?: boolean;
  toggle?: () => void;
  posX?: number;
  posY?: number;
  threadsRef?: any;
  setShowThreads?: any;
  showThreads?: boolean;
  view?: ECaseViews;
  showCreateFolder?: boolean;
  setShowCreateFolder?: (t: boolean) => void;
  selectedElements?: ICaseSimple[];
  setSelectedElements?: (cases: ICaseSimple[]) => void;
  rightSide?: boolean;
  dropdown?: boolean;
  isRightClicked?: boolean;
  statuses: IStatus[];
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const auth = useAuth();
  const ability = useContext(AbilityContext);
  const userId = getUserId(auth.user!);
  const { mutate: setDesk } = deskService.useSetDesk();
  const { mutate: deleteCase } = casesService.useDeleteCase();
  const { mutate: archiveCase } = casesService.useArchiveCase();
  const { mutate: redirect } = casesService.useRedirect();

  const { caseId } = useParams();

  const [showTags, setShowTags] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showRedirect, setShowRedirect] = useState(false);
  const [showStatus, setShowStatus] = useState(false);

  const [status, setStatus] = useState<IStatus>(
    statuses ? statuses.find((s) => s.Id === pack.StatusId) : null
  );

  const handleStatusUpdate = (status?: IStatus) => {
    setStatus(status);
    setShowStatus(false);
  };

  const outsideRef = useRef(null);

  useOnClickOutside(outsideRef, () => {
    if (showOptions) {
      toggle?.();
    }
  });

  useEffect(() => {
    if (!showTags) return;
    setShowDelete(false);
    setShowRedirect(false);
  }, [showTags]);

  useEffect(() => {
    if (!showDelete) return;
    setShowTags(false);
    setShowRedirect(false);
  }, [showTags]);

  useEffect(() => {
    if (!showRedirect) return;
    setShowDelete(false);
    setShowTags(false);
  }, [showTags]);

  const { cases, setCases } = useContext(CasesContext);

  const handleAddToDesk = () => {
    const newCases = [...cases];
    const items = [];

    if (selectedElements && selectedElements.length > 1) {
      for (const element of selectedElements) {
        const caseItem = newCases.find((c) => c.Id === element.Id);
        if (caseItem) {
          caseItem.IsDeskActive = !caseItem.IsDeskActive;
        }

        items.push({ Id: element.Id, Kind: element.Kind });
      }
    } else {
      const newCases = [...cases];
      const caseItem = newCases.find((c) => c.Id === pack.Id);
      if (caseItem) {
        caseItem.IsDeskActive = !caseItem.IsDeskActive;
      }
      items.push({ Id: pack.Id, Kind: pack.Kind });
    }

    setCases(newCases);

    setDesk(
      {
        Items: items,
        Show: pack.IsDeskActive,
      },
      {
        onSuccess: () => {},
      }
    );
  };

  const handleClicke = (e: any) => {
    // if (e.code === "Delete" && showOptions) {
    //   handleDeleteCase();
    // }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleClicke);

    return () => {
      window.removeEventListener("keydown", handleClicke);
    };
  }, [showOptions]);

  const handleDeleteCase = () => {
    const newCases = [...cases];

    deleteCase(pack, {
      onSuccess: () => {
        setCases(newCases.filter((p) => p.Id !== pack.Id));

        if (caseId === pack.Id) {
          navigate("/cases");
          localStorage.removeItem("last_case");
        }
      },
      onError: () => {
        archiveCase(pack, {
          onSuccess: () => {
            setCases(newCases.filter((p) => p.Id !== pack.Id));

            if (caseId === pack.Id) {
              navigate("/cases");
              localStorage.removeItem("last_case");
            }
          },
        });
      },
    });
  };

  const handleRedirect = async (workspaceMember: IWorkspaceMember) => {
    const myKeys = await getKeys(userId!);

    const c = await axiosInstance.get(`/case?id=${pack.Id}`);

    const id = pack.Id;
    const Kind = pack.Kind;

    const encryptionKey = c.data.Keys[0];

    const uint = await reEncrypt(userId, workspaceMember.UserId, encryptionKey);
    const readyToSend = await readAsBase64(uint);

    redirect(
      {
        CaseId: pack.Id,
        ReceiverId: workspaceMember.UserId,
        Keys: [{ Id: c.data.Keys[0].Id!, Key: readyToSend }],
      },
      {
        onSuccess: () => {
          setShowRedirect(false);

          let newCases = [...cases];

          newCases = newCases.filter((cc) => cc.Id !== pack.Id);
          setCases(newCases);
          navigate("/cases");
        },
      }
    );
  };

  const handleNewTab = () => {
    // window.open(
    //   `${
    //     import.meta.env.VITE_APP_SITE ?? "https://alfa.pocztaprawnicza.pl"
    //   }/fullscreen/cases/${pack?.Id}/chat`
    // );
    window.open(
      `${
        import.meta.env.VITE_APP_SITE ?? "https://alfa.pocztaprawnicza.pl"
      }/cases/${pack?.Id}/chat?fullscreen=1`
    );
  };

  const handleUpdateTags = (tags: ITag[]) => {
    const newCases = [...cases];

    const el = newCases.find((c) => c.Id === pack.Id && c.Kind === pack.Kind);

    if (el) {
      el.TagIds = tags.map((t) => t.Id);
    }

    pack.TagIds = tags.map((t) => t.Id);

    setCases(newCases);
  };

  const { modals, setModals, setOptions } = useContext(ModalsManagerContext);

  const [out, setOut] = useState<Option[]>([]);

  useEffect(() => {
    if (!pack) return;

    const c = cases.find((c) => c.Id === pack.Id);

    let options: Option[] = [
      {
        Icon: EditIcon,
        additional: false,
        callback: () => {
          setOptions({ item: pack });
          setModals({ ...modals, createCase: true, hide: false });
        },
        canMultiple: true,
        isEnabled: true,
        name: t("common.edit"),
      },
      {
        Icon: !c?.IsDeskActive ? DeskIcon : DeskRemoveIcon,
        additional: false,
        callback: () => {
          handleAddToDesk();
        },
        canMultiple: true,
        isEnabled: true,
        name: !c?.IsDeskActive ? t("cases.pinToDesk") : t("cases.unpinFromDesk"),
      },
      {
        Icon: FlagIcon,
        additional: false,
        callback: () => {
          setShowStatus(true);
          if (dropdown) {
            toggle();
          }
        },
        canMultiple: true,
        isEnabled: true,
        name: t("common.status"),
      },
      {
        Icon: LabelIcon,
        additional: false,
        callback: () => {
          setShowTags(true);
        },
        canMultiple: true,
        isEnabled: true,
        name: t("common.label"),
      },
      {
        Icon: CalendarIcon,
        additional: true,
        callback: () => {
          setModals({ ...modals, createTask: true, hide: false });
        },
        canMultiple: true,
        isEnabled: ability.can("accessModule", "tasks"),
        name: t("cases.newAction"),
      },
      {
        Icon: LinkIcon,
        additional: true,
        callback: () => {},
        canMultiple: true,
        isEnabled: true,
        name: t("cases.linkCases"),
      },
      // {
      //   Icon: JoinIcon,
      //   additional: true,
      //   callback: () => {},
      //   canMultiple: true,
      //   isEnabled: true,
      //   name: "Scal teczki",
      // },
      // {
      //   Icon: Redirect2Icon,
      //   additional: true,
      //   callback: () => {},
      //   canMultiple: true,
      //   isEnabled: true,
      //   name: "Udostępnij",
      // },
      {
        Icon: ForwardIcon,
        additional: true,
        callback: () => {},
        canMultiple: true,
        isEnabled: true,
        name: t("cases.forward"),
      },
      {
        Icon: NewTabIcon,
        additional: false,
        callback: () => {
          handleNewTab();
        },
        canMultiple: true,
        isEnabled: true,
        name: t("cases.newTab"),
      },
      {
        Icon: BinIcon,
        additional: true,
        callback: () => {
          handleDeleteCase();
        },
        canMultiple: true,
        isEnabled: true,
        name: t("common.delete"),
      },
    ];

    if (rightSide) {
      options = options.map((op) => {
        op.additional = true;

        return op;
      });
    }

    setOut(options);
  }, [cases, pack]);

  if (!pack) return <></>;

  return (
    <>
      <OptionsCard
        onClickAttachIcon={() => {}}
        refetch={() => {}}
        selectedElements={[]}
        toggle={toggle}
        showOptions={showOptions}
        rightSide={rightSide}
        refWrapper={refWrapper}
        outsideOptions={out}
        dropdown={dropdown}
        isRightClicked={isRightClicked}
      />

      {showStatus && (
        <Popper
          anchorEl={refWrapper?.current}
          open={showStatus}
          setOpen={setShowStatus}
        >
          <StatusModal
            item={pack}
            toggle={setShowStatus}
            selectedStatus={status}
            afterUpdate={handleStatusUpdate}
          />
        </Popper>
      )}

      {showTags && (
        <Popper
          anchorEl={refWrapper?.current}
          open={showTags}
          setOpen={setShowTags}
        >
          <ChooseTagNew
            toggle={setShowTags}
            updateTags={handleUpdateTags}
            type={TagType.Cases}
            //@ts-ignore
            toTag={pack}
          />
        </Popper>
      )}
    </>
  );
};

export default CaseOptionsCard;
